/**
 * Renders a snake_case backend enum token (`year_round`) as admin-facing prose
 * (`Year round`). Admin surfaces are English-only, so these tokens carry no
 * translations.
 */
export function humanize(token: string): string {
  return token
    .split("_")
    .map((part) => `${part[0]?.toUpperCase() ?? ""}${part.slice(1)}`)
    .join(" ");
}
